import {gsap, Expo, Power1} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {VideoPlayer} from '../parts/video-player'
import {SplitText} from 'gsap/SplitText'
import CustomEase from 'gsap/CustomEase'
import {breakpointUp, getScreenHeight, pxToScreenSize} from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

let symbolVideoTl;
window.initSymbolVideoSignAnimation = () => {

  if (!$('.block-symbol-video').length) return false
  gsap.set('#symbol-video .btn-layover', {opacity: 0})
  gsap.set('#symbol-video .js--custom-small-video-cursor .c-btn', {opacity: 0})

  const clearSymbolVideo = () => {
    if (symbolVideoTl) {
      ScrollTrigger.getById('symbolVideo').kill(true)
      gsap.set('#symbol-video .short-video-symbol', {clearProps: true})
      symbolVideoTl.kill(true)
      symbolVideoTl = null
    }
  }
  clearSymbolVideo();
  const shortVideoPlayer = new VideoPlayer('.block-symbol-video .short-video')
  const block = document.querySelector('#symbol-video')

  const screenH2x = getScreenHeight()
  const c_height = pxToScreenSize(82) //getScreenHeight() - content.clientHeight

  symbolVideoTl = gsap.timeline({
    scrollTrigger: {
      id: 'symbolVideo',
      trigger: '#symbol-video',
      pin: '#symbol-video-pin',
      start: $(window).width() < 1280 ? 'top top' : `top-=${c_height} top`,
      end: `+=${screenH2x}`,
      scrub: 1,
      //markers: true
      onLeave: () => {
        const charsCount = $('#symbol-content .split-char').length

        gsap.fromTo('#symbol-content .split-char', {opacity: 0}, {opacity: 1, duration: 0.3, stagger: 0.01})
        gsap.fromTo('#symbol-content .split-char', {y: 10, rotateX: -90}, {
          rotateX: 0,
          y: 0,
          duration: 0.6,
          stagger: 0.015,
          ease: CustomEase.create("custom", "M0,0 C0.435,0.25 0.15,0.965 1,1 ")
        })

        let delay = 0.3 + (charsCount * 0.015)

        gsap.fromTo('#symbol-content p', {opacity: 0}, {opacity: 1, delay: delay, duration: 0.25})
        gsap.fromTo('#symbol-video .btn-layover', {opacity: 0}, {opacity: 1, duration: 0.5})
        gsap.fromTo('#symbol-video .js--custom-small-video-cursor .c-btn', {opacity: 0}, {opacity: 1, duration: 0.5})
      },
      onEnterBack: () => {
        gsap.set('#symbol-content .split-char', {opacity: 0, y: 10, rotateX: -90})
        gsap.set('#symbol-content p', {opacity: 0})
        gsap.set('#symbol-video .btn-layover', {opacity: 0})
        gsap.set('#symbol-video .js--custom-small-video-cursor .c-btn', {opacity: 0})
      },
    }
  })

  symbolVideoTl.fromTo('#symbol-video .short-video-symbol .svg-container', {
    height: $(window).width() < 992 ? '110rem' : '150rem',
    width:  $(window).width() < 992 ? '110rem' : '150rem',
  }, {height: '10000rem', width: '10000rem', ease: Power1.easeIn}, 0)
  symbolVideoTl.fromTo('#symbol-video .short-video-symbol', {rotate: 0}, {
    rotate: 180,
    onComplete: removeNonClick
  }, 0)
  symbolVideoTl.fromTo('#symbol-video .short-video-symbol', {opacity: 1}, {opacity: 0, duration: 0.01})

  function removeNonClick() {
    block.classList.remove('not-click')
  }

}

let splitTextInstances = [];

window.initSymbolVideoTextAnimation = () => {

  if (!$('.block-symbol-video').length) return false

  const clearTextAnimation = () => {
    if (splitTextInstances.length > 0) {
      splitTextInstances.forEach(instance => {
        instance.revert();
      });
      splitTextInstances = [];
    }
  }
  clearTextAnimation();
  if ($(window).width() > 991) {
    const texts = document.querySelectorAll('#symbol-content h3')
    texts.forEach(text => {
      const splitTextInstance = new SplitText(text, {
        type: "lines, words, chars",
        linesClass: "split-line",
        charsClass: 'split-char',
        position: 'relative',
        reduceWhiteSpace: false
      })
      splitTextInstances.push(splitTextInstance); // Store reference to each SplitText instance
    })
    gsap.set('#symbol-content .split-char, #symbol-content p', {opacity: 0})
  }
}

$(document).ready(function () {
  initSymbolVideoTextAnimation()
  initSymbolVideoSignAnimation()
});


